import { showUpdateDialog } from "@accessinformatica/service-worker";
import { toast } from "react-toastify";
import packagejson from '../../../package.json';
import { parseBlobToObject } from "../../util/files";
import { logout } from "../actions/auth";
import { setErrorMessage } from "../actions/error";
import { showWarningDialog } from "../actions/warning";

const error401 = (store) => {
  store.dispatch(logout());
  return toast.error("Sesión expirada", {
    toastId: 401
  })
}

const ErrorMiddleware = (store) => (next) => async (action) => {
  if (action.type.includes("persist")) return next(action);

  if (action.type.includes("_FULFILLED")) {
    if (action.payload?.data?.MensajeAdvertencia) {
      store.dispatch(showWarningDialog(action.payload.data.MensajeAdvertencia));
      delete action.payload.data.MensajeAdvertencia;
    }
  }

  if (action.type.includes("_REJECTED")) {
    if (action.payload?.hideErrorToast) {
      return next(action);
    }
    store.dispatch(
      setErrorMessage(
        action.payload?.request?.status,
        action.payload?.data?.Message
      )
    );

    let errorMessage =
      "Estamos teniendo problemas para conectarnos con el servidor, por favor inténtelo nuevamente.";
    if (action.payload?.response?.data instanceof Blob) {
      let blobObject = await parseBlobToObject(action.payload.response.data);
      if (blobObject?.Message) {
        errorMessage = blobObject.Message;
      }
    }

    if (action.payload.request.status === 426) {
      if (action.payload.request.version === packagejson.version) {
        error401(store);
        return;
      } else {
        store.dispatch(showUpdateDialog());
        return;
      }
    }

    if (action.payload?.response?.data?.Message) {
      errorMessage = action.payload?.response?.data?.Message;
    } else if (
      action.payload?.request?.status === 401 ||
      action.payload?.request?.status === 0
    ) {
      error401(store);
    }

    const toastOptions = {};
    if (action?.meta?.autoClose === false) {
      toastOptions.autoClose = false;
    }

    toast.error(errorMessage, toastOptions);
  }

  return next(action);
};

export default ErrorMiddleware;
